var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-main",
    [
      _c("div", { staticClass: "tabs-wrt" }, [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible",
              },
            ],
            staticClass: "contextmenu",
            style: { left: _vm.left + "px", top: "20px" },
          },
          [
            _vm.selectTag.path !== "/index"
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.closeSelectedTag(_vm.selectTag)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("close")))]
                )
              : _vm._e(),
            _c("li", { on: { click: _vm.closeAllTags } }, [
              _vm._v(_vm._s(_vm.$t("closeAll"))),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "content-tabs" },
          [
            _vm.showTabs
              ? _c(
                  "el-tabs",
                  {
                    ref: "topTabs",
                    attrs: { type: "card" },
                    on: {
                      "tab-click": _vm.tabClick,
                      "tab-remove": _vm.removeTab,
                    },
                    nativeOn: {
                      contextmenu: function ($event) {
                        $event.preventDefault()
                        return _vm.openMenu($event)
                      },
                    },
                    model: {
                      value: _vm.editableTabsValue,
                      callback: function ($$v) {
                        _vm.editableTabsValue = $$v
                      },
                      expression: "editableTabsValue",
                    },
                  },
                  _vm._l(_vm.visitedViews, function (item) {
                    return _c(
                      "el-tab-pane",
                      {
                        key: item.path,
                        attrs: {
                          name: item.path,
                          closable: item.name !== "index",
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    item.tagsName ? item.tagsName : item.name
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm.responseNetTime
              ? _c(
                  "div",
                  {
                    staticClass: "net-monitor-wrap",
                    class: { "net-monitor-wran": _vm.responseNetTime > 5000 },
                  },
                  [
                    _c("span", { staticClass: "icon" }),
                    _c("div", { attrs: { id: "net_monitor_div2" } }, [
                      _vm._v(_vm._s(_vm.responseNetTime) + "ms"),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "keep-alive",
        { attrs: { include: _vm.cachedViews } },
        [
          _vm.routerFlag &&
          this.$route.name != "smartQuery" &&
          this.$route.name != "historyQuery"
            ? _c("router-view", {
                ref: "_contentView",
                staticClass: "main-container",
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _vm.routerFlag &&
          ["smartQuery", "historyQuery"].includes(this.$route.name)
            ? _c("router-view", {
                key: this.$route.fullPath,
                ref: "_contentView",
                staticClass: "main-container",
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }